import { createRoutine } from "../utils/routine.utils";
export var getInvites = createRoutine("INVITES_GET");
export var acceptAllInvites = createRoutine("INVITES_ACCEPT_ALL");
export var acceptInvite = createRoutine("INVITES_ACCEPT");
export var declineInvite = createRoutine("INVITES_DECLINE");
